/**
 *Created by jmmartinez on 18/03/19
 *  v 1.1 06/08/2019 Modificado loadListaEntidad para añadir el tipo de llamada completa/minimo
 *  v 1.2 31/03/2020 Añadida la validación de numéricos en la funcion validarEntidad.
 *  v.1.3 08/03/2020 Añadidos métodos eliminarEntidad, eliminarEntidadCondicion y insertarModificarEntidad
 *  v.1.4 16/01/2025 En el metodo validarEntidad, añadida la comprobacion if (elementoConfig == undefined)
 **/

import {servidor, servicioRestful, servicioRestfulMinimo} from "../../../dental/Configuracion";
import ClienteRestful from "../network/ClienteRestful";
import {CAMPOTIPO_ENTERO, CAMPOTIPO_FLOTANTE, CAMPOTIPO_MONEDA} from "../UI/TiposCampos";



export const loadListaEntidad= (nombreClase, filtro, callbackOk) => {
    let url= servidor + servicioRestful + "list/" + nombreClase;
    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(filtro, response => {
        //console.log(response);
        let entidadLista= response.lo;
        callbackOk && callbackOk(entidadLista);
    });
}


export const validarEntidad= (elementoConfig, datos) => {
    console.log("*** validarRow----------");
    console.log(datos);

    if (elementoConfig == undefined)
        return true;

    let valido= true;
    elementoConfig.campos.forEach((campo) => {
        //console.log("campo: ", campo);
        //Si es numerico comprobamos que sea un número
        if (campo.tipo === CAMPOTIPO_ENTERO || campo.tipo === CAMPOTIPO_FLOTANTE || campo.tipo === CAMPOTIPO_MONEDA){
           let valor= datos[campo.campo];
           //console.log("valor: ", valor);
           if (isNaN(valor)) {
               valido = false;
               //console.log(campo.campo + " no valido no número");
           }
        }
        if (campo.obligatorio) {
            //console.log("campo.campo: ", campo.campo);
            if (!datos[campo.campo]) {
                valido = false;
                //console.log(campo.campo + " no valido.");
            }
        }

    });
    return valido;
}

export const eliminarEntidad= (className, entidad, callbackOK, callbackKO) => {
    let codigo = entidad.codigo;
    let empresaCodigo = entidad.empresaCodigo ? entidad.empresaCodigo : -1;
    let url = servidor + servicioRestfulMinimo + className + "/" + codigo + "/" + empresaCodigo;
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doDelete(response => {
            if (clienteRestful.exito && response)
                callbackOK && callbackOK();
            else
                callbackKO && callbackKO();

        },
        reponse => {
            callbackKO && callbackKO();
        }

    );
}


export const eliminarEntidadCondicion= (className, condicion, callbackOK, callbackKO) => {
    //console.log("Eliminar condicion");
    //console.log(condicion);
    let url = servidor + servicioRestfulMinimo + "deletecondicion/" + className;
    //console.log(url);
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost( condicion, response => {
            if (clienteRestful.exito && response)
                callbackOK && callbackOK();
            else
                callbackKO && callbackKO();

        },
        reponse => {
            callbackKO && callbackKO();
        }

    );
}


export const insertarModificarEntidad= (className, entidad, callbackOK, callbackKO) => {
    let url = servidor + servicioRestfulMinimo + className;
    const clienteRestful = new ClienteRestful().setUrl(url);
    clienteRestful.doPost(entidad, response => {
        if (clienteRestful.exito && response)
            callbackOK && callbackOK();
        else
            callbackKO && callbackKO();

    },
     reponse => {
         callbackKO && callbackKO();
     }

    );
}
